import { AxiosResponse } from 'axios';

import axios from 'axios';
import { axiosIntance, haciendaApiUrl } from '../../../config/ApiConfig';
import {
  Setting,
  CabysCatalog,
  LatestCabysCodes,
  EconomicActivity,
} from '../../../types/settings/Setting';

export const SettingsDao = {
  list: (accountId: string): Promise<AxiosResponse<Setting[]>> => {
    return axiosIntance.get(`/settings/list?account=${accountId}`);
  },
  getCatalogCabys: (
    search?: string
  ): Promise<AxiosResponse<CabysCatalog[]>> => {
    let query = '';
    if (search) {
      query = `?search=${search}`;
    }
    return axiosIntance.get(`settings/catalog-cabys${query}`);
  },
  getLatestCabysCodes: (
    accountId: string
  ): Promise<AxiosResponse<LatestCabysCodes[]>> => {
    return axiosIntance.get(
      `settings/cabys-code-used-by-account?account=${accountId}`
    );
  },
  // Nuevo método para actividades económicas
  getEconomicActivities: (search?: string): Promise<AxiosResponse<EconomicActivity[]>> => {
    let query = ''
    if(search) {
      query = `?search=${search}`
    }
    return axiosIntance.get(`settings/catalog-economic-activities${query}`);
  },
  // Obtener actividades económicas por identificación (proxy backend)
  getEconomicActivitiesByIdentification: (
    identificacion: string
  ): Promise<AxiosResponse<{ 
    nombre?: string;
    tipoIdentificacion?: string;
    actividades: { codigo: string; descripcion: string; estado?: string; tipo?: string }[] 
  }>> => {
    return axios.get(`${haciendaApiUrl}fe/ae?identificacion=${identificacion}`);
  },
};

